import { Link } from "react-router-dom";

export default function Footer() {
  return (
    <footer className="w-full bg-background-100 border-t border-background-200/80 mt-16 md:mt-24">
      <div className="w-full px-4 md:px-8 pt-10 pb-24 md:pt-14 md:pb-14">
        <div className="grid grid-cols-1 md:grid-cols-4 gap-8 md:gap-10">
          <div className="md:col-span-2 max-w-md">
            <div className="flex items-center gap-2 mb-4">
              <span className="w-9 h-9 rounded-lg bg-primary-500 flex items-center justify-center">
                <i className="ri-film-line text-background-50 text-xl" />
              </span>
              <span className="font-heading font-bold text-lg text-foreground-950">
                动漫<span className="text-primary-500">网站</span>
              </span>
            </div>
            <p className="text-sm text-foreground-600 leading-relaxed">
              动漫网站是面向动漫爱好者的资源与资讯聚合平台，汇聚精选动漫全集与最新动画资讯，让你轻松在线浏览与了解动漫动态。
            </p>
            <div className="flex items-center gap-3 mt-5">
              <a
                href="https://xiyuanfu001.com.cn"
                target="_blank"
                rel="noreferrer"
                className="w-9 h-9 rounded-full bg-background-200 flex items-center justify-center text-foreground-600 hover:bg-primary-500 hover:text-background-50 transition-colors"
                aria-label="微博"
              >
                <i className="ri-weibo-fill" />
              </a>
              <a
                href="https://www.bilibili.com"
                target="_blank"
                rel="noreferrer"
                className="w-9 h-9 rounded-full bg-background-200 flex items-center justify-center text-foreground-600 hover:bg-primary-500 hover:text-background-50 transition-colors"
                aria-label="哔哩哔哩"
              >
                <i className="ri-bilibili-fill" />
              </a>
              <a
                href="https://www.youtube.com"
                target="_blank"
                rel="noreferrer"
                className="w-9 h-9 rounded-full bg-background-200 flex items-center justify-center text-foreground-600 hover:bg-primary-500 hover:text-background-50 transition-colors"
                aria-label="视频频道"
              >
                <i className="ri-youtube-fill" />
              </a>
            </div>
          </div>

          <div>
            <h4 className="font-heading font-semibold text-foreground-950 mb-4 text-sm">
              <Link to="/" className="hover:text-primary-600">快速导航</Link>
            </h4>
            <ul className="space-y-2.5 text-sm">
              <li><Link to="/" className="text-foreground-600 hover:text-primary-600">首页</Link></li>
              <li><Link to="/category/hot-blood" className="text-foreground-600 hover:text-primary-600">动漫分类</Link></li>
              <li><Link to="/news" className="text-foreground-600 hover:text-primary-600">动漫资讯</Link></li>
              <li><Link to="/favorites" className="text-foreground-600 hover:text-primary-600">我的收藏</Link></li>
            </ul>
          </div>

          <div>
            <h4 className="font-heading font-semibold text-foreground-950 mb-4 text-sm">
              <Link to="/about" className="hover:text-primary-600">关于与帮助</Link>
            </h4>
            <ul className="space-y-2.5 text-sm">
              <li><Link to="/about" className="text-foreground-600 hover:text-primary-600">关于我们</Link></li>
              <li><Link to="/contact" className="text-foreground-600 hover:text-primary-600">联系我们</Link></li>
              <li><Link to="/search?q=热血" className="text-foreground-600 hover:text-primary-600">热门搜索</Link></li>
              <li><Link to="/news" className="text-foreground-600 hover:text-primary-600">资讯中心</Link></li>
            </ul>
          </div>
        </div>

        <div className="mt-10 pt-6 border-t border-background-200/80 flex flex-col sm:flex-row sm:items-center sm:justify-between gap-3">
          <p className="text-xs text-foreground-500">
            © 2024 动漫网站 · 本站为演示站点，动漫资源与资讯均为示例内容
          </p>
          <p className="text-xs text-foreground-500">
            精选动漫全集 · 最新动画资讯 · 面向动漫爱好者
          </p>
        </div>
      </div>
    </footer>
  );
}